function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/model/differ
 */
import Position from './position';
import Range from './range';
/**
 * Calculates the difference between two model states.
 *
 * Receives operations that are to be applied on the model document. Marks parts of the model document tree which
 * are changed and saves the state of these elements before the change. Then, it compares saved elements with the
 * changed elements, after all changes are applied on the model document. Calculates the diff between saved
 * elements and new ones and returns a change set.
 */

var Differ = /*#__PURE__*/function () {
  /**
   * Creates a `Differ` instance.
   *
   * @param {module:engine/model/markercollection~MarkerCollection} markerCollection Model's marker collection.
   */
  function Differ(markerCollection) {
    _classCallCheck(this, Differ);

    /**
     * Reference to the model's marker collection.
     *
     * @private
     * @type {module:engine/model/markercollection~MarkerCollection}
     */
    this._markerCollection = markerCollection;
    /**
     * A map that stores changes that happened in a given element.
     *
     * The keys of the map are references to the model elements.
     * The values of the map are arrays with changes that were done on this element.
     *
     * @private
     * @type {Map}
     */

    this._changesInElement = new Map();
    /**
     * A map that stores "element's children snapshots". A snapshot is representing children of a given element before
     * the first change was applied on that element. Snapshot items are objects with two properties: `name`,
     * containing the element name (or `'$text'` for a text node) and `attributes` which is a map of the node's attributes.
     *
     * @private
     * @type {Map}
     */

    this._elementSnapshots = new Map();
    /**
     * A map that stores all changed markers.
     *
     * The keys of the map are marker names.
     * The values of the map are objects with the `oldRange` and `newRange` properties. They store the marker range
     * state before and after the change.
     *
     * @private
     * @type {Map}
     */

    this._changedMarkers = new Map();
    /**
     * Stores the number of changes that were processed. Used to order the changes chronologically. It is important
     * when changes are sorted.
     *
     * @private
     * @type {Number}
     */

    this._changeCount = 0;
    /**
     * For efficiency purposes, `Differ` stores the change set returned by the differ after {@link #getChanges} call.
     * Cache is reset each time a new operation is buffered. If the cache has not been reset, {@link #getChanges} will
     * return the cached value instead of calculating it again.
     *
     * This property stores those changes that did not take place in graveyard root.
     *
     * @private
     * @type {Array.<Object>|null}
     */

    this._cachedChanges = null;
    /**
     * For efficiency purposes, `Differ` stores the change set returned by the differ after the {@link #getChanges} call.
     * The cache is reset each time a new operation is buffered. If the cache has not been reset, {@link #getChanges} will
     * return the cached value instead of calculating it again.
     *
     * This property stores all changes evaluated by `Differ`, including those that took place in the graveyard.
     *
     * @private
     * @type {Array.<Object>|null}
     */

    this._cachedChangesWithGraveyard = null;
  }
  /**
   * Informs whether there are any changes buffered in `Differ`.
   *
   * @readonly
   * @type {Boolean}
   */


  _createClass(Differ, [{
    key: "isEmpty",
    get: function get() {
      return this._changesInElement.size == 0 && this._changedMarkers.size == 0;
    }
    /**
     * Marks given `item` in differ to be "refreshed". It means that the item will be marked as removed and inserted in the differ changes
     * set, so it will be effectively re-converted when differ changes will be handled by a dispatcher.
     *
     * @param {module:engine/model/item~Item} item Item to refresh.
     */

  }, {
    key: "refreshItem",
    value: function refreshItem(item) {
      if (this._isInInsertedElement(item.parent)) {
        return;
      }

      this._markRemove(item.parent, item.startOffset, item.offsetSize);

      this._markInsert(item.parent, item.startOffset, item.offsetSize);

      var range = Range._createOn(item);

      var _iterator = _createForOfIteratorHelper(this._markerCollection.getMarkersIntersectingRange(range)),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var marker = _step.value;
          var markerRange = marker.getRange();
          this.bufferMarkerChange(marker.name, markerRange, markerRange, marker.affectsData);
        } // Clear cache after each buffered operation as it is no longer valid.

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this._cachedChanges = null;
    }
    /**
     * Buffers the given operation. An operation has to be buffered before it is executed.
     *
     * Operation type is checked and it is checked which nodes it will affect. These nodes are then stored in `Differ`
     * in the state before the operation is executed.
     *
     * @param {module:engine/model/operation/operation~Operation} operation An operation to buffer.
     */

  }, {
    key: "bufferOperation",
    value: function bufferOperation(operation) {
      // Below we take an operation, check its type, then use its parameters in marking (private) methods.
      // The general rule is to not mark elements inside inserted element. All inserted elements are re-rendered.
      // Marking changes in them would cause a "double" changing then.
      //
      switch (operation.type) {
        case 'insert':
          {
            if (this._isInInsertedElement(operation.position.parent)) {
              return;
            }

            this._markInsert(operation.position.parent, operation.position.offset, operation.nodes.maxOffset);

            break;
          }

        case 'addAttribute':
        case 'removeAttribute':
        case 'changeAttribute':
          {
            var _iterator2 = _createForOfIteratorHelper(operation.range.getItems({
              shallow: true
            })),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var item = _step2.value;

                if (this._isInInsertedElement(item.parent)) {
                  continue;
                }

                this._markAttribute(item);
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }

            break;
          }

        case 'remove':
        case 'move':
        case 'reinsert':
          {
            // When range is moved to the same position then not mark it as a change.
            // See: https://github.com/ckeditor/ckeditor5-engine/issues/1664.
            if (operation.sourcePosition.isEqual(operation.targetPosition) || operation.sourcePosition.getShiftedBy(operation.howMany).isEqual(operation.targetPosition)) {
              return;
            }

            var sourceParentInserted = this._isInInsertedElement(operation.sourcePosition.parent);

            var targetParentInserted = this._isInInsertedElement(operation.targetPosition.parent);

            if (!sourceParentInserted) {
              this._markRemove(operation.sourcePosition.parent, operation.sourcePosition.offset, operation.howMany);
            }

            if (!targetParentInserted) {
              this._markInsert(operation.targetPosition.parent, operation.getMovedRangeStart().offset, operation.howMany);
            }

            break;
          }

        case 'rename':
          {
            if (this._isInInsertedElement(operation.position.parent)) {
              return;
            }

            this._markRemove(operation.position.parent, operation.position.offset, 1);

            this._markInsert(operation.position.parent, operation.position.offset, 1);

            var range = Range._createFromPositionAndShift(operation.position, 1);

            var _iterator3 = _createForOfIteratorHelper(this._markerCollection.getMarkersIntersectingRange(range)),
                _step3;

            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var marker = _step3.value;
                var markerRange = marker.getRange();
                this.bufferMarkerChange(marker.name, markerRange, markerRange, marker.affectsData);
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }

            break;
          }

        case 'split':
          {
            var splitElement = operation.splitPosition.parent; // Mark that children of the split element were removed.

            if (!this._isInInsertedElement(splitElement)) {
              this._markRemove(splitElement, operation.splitPosition.offset, operation.howMany);
            } // Mark that the new element (split copy) was inserted.


            if (!this._isInInsertedElement(operation.insertionPosition.parent)) {
              this._markInsert(operation.insertionPosition.parent, operation.insertionPosition.offset, 1);
            } // If the split took the element from the graveyard, mark that the element from the graveyard was removed.


            if (operation.graveyardPosition) {
              this._markRemove(operation.graveyardPosition.parent, operation.graveyardPosition.offset, 1);
            }

            break;
          }

        case 'merge':
          {
            // Mark that the merged element was removed.
            var mergedElement = operation.sourcePosition.parent;

            if (!this._isInInsertedElement(mergedElement.parent)) {
              this._markRemove(mergedElement.parent, mergedElement.startOffset, 1);
            } // Mark that the merged element was inserted into graveyard.


            var graveyardParent = operation.graveyardPosition.parent;

            this._markInsert(graveyardParent, operation.graveyardPosition.offset, 1); // Mark that children of merged element were inserted at new parent.


            var mergedIntoElement = operation.targetPosition.parent;

            if (!this._isInInsertedElement(mergedIntoElement)) {
              this._markInsert(mergedIntoElement, operation.targetPosition.offset, mergedElement.maxOffset);
            }

            break;
          }
      } // Clear cache after each buffered operation as it is no longer valid.


      this._cachedChanges = null;
    }
    /**
     * Buffers a marker change.
     *
     * @param {String} markerName The name of the marker that changed.
     * @param {module:engine/model/range~Range|null} oldRange Marker range before the change or `null` if the marker has just
     * been created.
     * @param {module:engine/model/range~Range|null} newRange Marker range after the change or `null` if the marker was removed.
     * @param {Boolean} affectsData Flag indicating whether marker affects the editor data.
     */

  }, {
    key: "bufferMarkerChange",
    value: function bufferMarkerChange(markerName, oldRange, newRange, affectsData) {
      var buffered = this._changedMarkers.get(markerName);

      if (!buffered) {
        this._changedMarkers.set(markerName, {
          oldRange: oldRange,
          newRange: newRange,
          affectsData: affectsData
        });
      } else {
        buffered.newRange = newRange;
        buffered.affectsData = affectsData;

        if (buffered.oldRange == null && buffered.newRange == null) {
          // The marker is going to be removed (`newRange == null`) but it did not exist before the first buffered change
          // (`buffered.oldRange == null`). In this case, do not keep the marker in buffer at all.
          this._changedMarkers.delete(markerName);
        }
      }
    }
    /**
     * Returns all markers that should be removed as a result of buffered changes.
     *
     * @returns {Array.<Object>} Markers to remove. Each array item is an object containing the `name` and `range` properties.
     */

  }, {
    key: "getMarkersToRemove",
    value: function getMarkersToRemove() {
      var result = [];

      var _iterator4 = _createForOfIteratorHelper(this._changedMarkers),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _ref3 = _step4.value;

          var _ref2 = _slicedToArray(_ref3, 2);

          var name = _ref2[0];
          var change = _ref2[1];

          if (change.oldRange != null) {
            result.push({
              name: name,
              range: change.oldRange
            });
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return result;
    }
    /**
     * Returns all markers which should be added as a result of buffered changes.
     *
     * @returns {Array.<Object>} Markers to add. Each array item is an object containing the `name` and `range` properties.
     */

  }, {
    key: "getMarkersToAdd",
    value: function getMarkersToAdd() {
      var result = [];

      var _iterator5 = _createForOfIteratorHelper(this._changedMarkers),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _ref6 = _step5.value;

          var _ref5 = _slicedToArray(_ref6, 2);

          var name = _ref5[0];
          var change = _ref5[1];

          if (change.newRange != null) {
            result.push({
              name: name,
              range: change.newRange
            });
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      return result;
    }
    /**
     * Returns all markers which changed.
     *
     * @returns {Array.<Object>}
     */

  }, {
    key: "getChangedMarkers",
    value: function getChangedMarkers() {
      return Array.from(this._changedMarkers).map(function (item) {
        return {
          name: item[0],
          data: {
            oldRange: item[1].oldRange,
            newRange: item[1].newRange
          }
        };
      });
    }
    /**
     * Checks whether some of the buffered changes affect the editor data.
     *
     * Types of changes which affect the editor data:
     *
     * * model structure changes,
     * * attribute changes,
     * * changes of markers which were defined as `affectingData`.
     *
     * @returns {Boolean}
     */

  }, {
    key: "hasDataChanges",
    value: function hasDataChanges() {
      var _iterator6 = _createForOfIteratorHelper(this._changedMarkers),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _ref9 = _step6.value;

          var _ref8 = _slicedToArray(_ref9, 2);

          var change = _ref8[1];

          if (change.affectsData) {
            return true;
          }
        } // If markers do not affect the data, check whether there are some changes in elements.

      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      return this._changesInElement.size > 0;
    }
    /**
     * Calculates the diff between the old model tree state (the state before the first buffered operations since the last {@link #reset}
     * call) and the new model tree state (actual one). It should be called after all buffered operations are executed.
     *
     * The diff set is returned as an array of {@link module:engine/model/differ~DiffItem diff items}, each describing a change done
     * on the model. The items are sorted by the position on which the change happened. If a position
     * {@link module:engine/model/position~Position#isBefore is before} another one, it will be on an earlier index in the diff set.
     *
     * **Note**: Elements inside inserted element will not have a separate diff item, only the top most element change will be reported.
     *
     * Because calculating the diff is a costly operation, the result is cached. If no new operation was buffered since the
     * previous {@link #getChanges} call, the next call will return the cached value.
     *
     * @param {Object} options Additional options.
     * @param {Boolean} [options.includeChangesInGraveyard=false] If set to `true`, also changes that happened
     * in the graveyard root will be returned. By default, changes in the graveyard root are not returned.
     * @returns {Array.<module:engine/model/differ~DiffItem>} Diff between the old and the new model tree state.
     */

  }, {
    key: "getChanges",
    value: function getChanges() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        includeChangesInGraveyard: false
      };

      // If there are cached changes, just return them instead of calculating changes again.
      if (this._cachedChanges) {
        if (options.includeChangesInGraveyard) {
          return this._cachedChangesWithGraveyard.slice();
        } else {
          return this._cachedChanges.slice();
        }
      } // Will contain returned results.


      var diffSet = []; // Check all changed elements.

      var _iterator7 = _createForOfIteratorHelper(this._changesInElement.keys()),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var element = _step7.value;

          // Get changes for this element and sort them.
          var changes = this._changesInElement.get(element).sort(function (a, b) {
            if (a.offset === b.offset) {
              if (a.type != b.type) {
                // If there are multiple changes at the same position, "remove" change should be first.
                // If the order is different, for example, we would first add some nodes and then removed them
                // (instead of the nodes that we should remove).
                return a.type == 'remove' ? -1 : 1;
              }

              return 0;
            }

            return a.offset < b.offset ? -1 : 1;
          }); // Get children of this element before any change was applied on it.


          var snapshotChildren = this._elementSnapshots.get(element); // Get snapshot of current element's children.


          var elementChildren = _getChildrenSnapshot(element.getChildren()); // Generate actions basing on changes done on element.


          var actions = _generateActionsFromChanges(snapshotChildren.length, changes);

          var _i2 = 0; // Iterator in `elementChildren` array -- iterates through current children of element.

          var j = 0; // Iterator in `snapshotChildren` array -- iterates through old children of element.
          // Process every action.

          var _iterator9 = _createForOfIteratorHelper(actions),
              _step9;

          try {
            for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
              var action = _step9.value;

              if (action === 'i') {
                // Generate diff item for this element and insert it into the diff set.
                diffSet.push(this._getInsertDiff(element, _i2, elementChildren[_i2].name));
                _i2++;
              } else if (action === 'r') {
                // Generate diff item for this element and insert it into the diff set.
                diffSet.push(this._getRemoveDiff(element, _i2, snapshotChildren[j].name));
                j++;
              } else if (action === 'a') {
                var _diffSet;

                // Take attributes from saved and current children.
                var elementAttributes = elementChildren[_i2].attributes;
                var snapshotAttributes = snapshotChildren[j].attributes;
                var range = void 0;

                if (elementChildren[_i2].name == '$text') {
                  range = new Range(Position._createAt(element, _i2), Position._createAt(element, _i2 + 1));
                } else {
                  var index = element.offsetToIndex(_i2);
                  range = new Range(Position._createAt(element, _i2), Position._createAt(element.getChild(index), 0));
                } // Generate diff items for this change (there might be multiple attributes changed and
                // there is a single diff for each of them) and insert them into the diff set.


                (_diffSet = diffSet).push.apply(_diffSet, _toConsumableArray(this._getAttributesDiff(range, snapshotAttributes, elementAttributes)));

                _i2++;
                j++;
              } else {
                // `action` is 'equal'. Child not changed.
                _i2++;
                j++;
              }
            }
          } catch (err) {
            _iterator9.e(err);
          } finally {
            _iterator9.f();
          }
        } // Then, sort the changes by the position (change at position before other changes is first).

      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      diffSet.sort(function (a, b) {
        // If the change is in different root, we don't care much, but we'd like to have all changes in given
        // root "together" in the array. So let's just sort them by the root name. It does not matter which root
        // will be processed first.
        if (a.position.root != b.position.root) {
          return a.position.root.rootName < b.position.root.rootName ? -1 : 1;
        } // If change happens at the same position...


        if (a.position.isEqual(b.position)) {
          // Keep chronological order of operations.
          return a.changeCount - b.changeCount;
        } // If positions differ, position "on the left" should be earlier in the result.


        return a.position.isBefore(b.position) ? -1 : 1;
      }); // Glue together multiple changes (mostly on text nodes).

      for (var i = 1, prevIndex = 0; i < diffSet.length; i++) {
        var prevDiff = diffSet[prevIndex];
        var thisDiff = diffSet[i]; // Glue remove changes if they happen on text on same position.

        var isConsecutiveTextRemove = prevDiff.type == 'remove' && thisDiff.type == 'remove' && prevDiff.name == '$text' && thisDiff.name == '$text' && prevDiff.position.isEqual(thisDiff.position); // Glue insert changes if they happen on text on consecutive fragments.

        var isConsecutiveTextAdd = prevDiff.type == 'insert' && thisDiff.type == 'insert' && prevDiff.name == '$text' && thisDiff.name == '$text' && prevDiff.position.parent == thisDiff.position.parent && prevDiff.position.offset + prevDiff.length == thisDiff.position.offset; // Glue attribute changes if they happen on consecutive fragments and have same key, old value and new value.

        var isConsecutiveAttributeChange = prevDiff.type == 'attribute' && thisDiff.type == 'attribute' && prevDiff.position.parent == thisDiff.position.parent && prevDiff.range.isFlat && thisDiff.range.isFlat && prevDiff.position.offset + prevDiff.length == thisDiff.position.offset && prevDiff.attributeKey == thisDiff.attributeKey && prevDiff.attributeOldValue == thisDiff.attributeOldValue && prevDiff.attributeNewValue == thisDiff.attributeNewValue;

        if (isConsecutiveTextRemove || isConsecutiveTextAdd || isConsecutiveAttributeChange) {
          prevDiff.length++;

          if (isConsecutiveAttributeChange) {
            prevDiff.range.end = prevDiff.range.end.getShiftedBy(1);
          }

          diffSet[i] = null;
        } else {
          prevIndex = i;
        }
      }

      diffSet = diffSet.filter(function (v) {
        return v;
      }); // Remove `changeCount` property from diff items. It is used only for sorting and is internal thing.

      var _iterator8 = _createForOfIteratorHelper(diffSet),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var item = _step8.value;
          delete item.changeCount;

          if (item.type == 'attribute') {
            delete item.position;
            delete item.length;
          }
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }

      this._changeCount = 0; // Cache changes.

      this._cachedChangesWithGraveyard = diffSet.slice();
      this._cachedChanges = diffSet.filter(_changesInGraveyardFilter);

      if (options.includeChangesInGraveyard) {
        return this._cachedChangesWithGraveyard;
      } else {
        return this._cachedChanges;
      }
    }
    /**
     * Resets `Differ`. Removes all buffered changes.
     */

  }, {
    key: "reset",
    value: function reset() {
      this._changesInElement.clear();

      this._elementSnapshots.clear();

      this._changedMarkers.clear();

      this._cachedChanges = null;
    }
    /**
     * Saves and handles an insert change.
     *
     * @private
     * @param {module:engine/model/element~Element} parent
     * @param {Number} offset
     * @param {Number} howMany
     */

  }, {
    key: "_markInsert",
    value: function _markInsert(parent, offset, howMany) {
      var changeItem = {
        type: 'insert',
        offset: offset,
        howMany: howMany,
        count: this._changeCount++
      };

      this._markChange(parent, changeItem);
    }
    /**
     * Saves and handles a remove change.
     *
     * @private
     * @param {module:engine/model/element~Element} parent
     * @param {Number} offset
     * @param {Number} howMany
     */

  }, {
    key: "_markRemove",
    value: function _markRemove(parent, offset, howMany) {
      var changeItem = {
        type: 'remove',
        offset: offset,
        howMany: howMany,
        count: this._changeCount++
      };

      this._markChange(parent, changeItem);

      this._removeAllNestedChanges(parent, offset, howMany);
    }
    /**
     * Saves and handles an attribute change.
     *
     * @private
     * @param {module:engine/model/item~Item} item
     */

  }, {
    key: "_markAttribute",
    value: function _markAttribute(item) {
      var changeItem = {
        type: 'attribute',
        offset: item.startOffset,
        howMany: item.offsetSize,
        count: this._changeCount++
      };

      this._markChange(item.parent, changeItem);
    }
    /**
     * Saves and handles a model change.
     *
     * @private
     * @param {module:engine/model/element~Element} parent
     * @param {Object} changeItem
     */

  }, {
    key: "_markChange",
    value: function _markChange(parent, changeItem) {
      // First, make a snapshot of this parent's children (it will be made only if it was not made before).
      this._makeSnapshot(parent); // Then, get all changes that already were done on the element (empty array if this is the first change).


      var changes = this._getChangesForElement(parent); // Then, look through all the changes, and transform them or the new change.


      this._handleChange(changeItem, changes); // Add the new change.


      changes.push(changeItem); // Remove incorrect changes. During transformation some change might be, for example, included in another.
      // In that case, the change will have `howMany` property set to `0` or less. We need to remove those changes.

      for (var i = 0; i < changes.length; i++) {
        if (changes[i].howMany < 1) {
          changes.splice(i, 1);
          i--;
        }
      }
    }
    /**
     * Gets an array of changes that have already been saved for a given element.
     *
     * @private
     * @param {module:engine/model/element~Element} element
     * @returns {Array.<Object>}
     */

  }, {
    key: "_getChangesForElement",
    value: function _getChangesForElement(element) {
      var changes;

      if (this._changesInElement.has(element)) {
        changes = this._changesInElement.get(element);
      } else {
        changes = [];

        this._changesInElement.set(element, changes);
      }

      return changes;
    }
    /**
     * Saves a children snapshot for a given element.
     *
     * @private
     * @param {module:engine/model/element~Element} element
     */

  }, {
    key: "_makeSnapshot",
    value: function _makeSnapshot(element) {
      if (!this._elementSnapshots.has(element)) {
        this._elementSnapshots.set(element, _getChildrenSnapshot(element.getChildren()));
      }
    }
    /**
     * For a given newly saved change, compares it with a change already done on the element and modifies the incoming
     * change and/or the old change.
     *
     * @private
     * @param {Object} inc Incoming (new) change.
     * @param {Array.<Object>} changes An array containing all the changes done on that element.
     */

  }, {
    key: "_handleChange",
    value: function _handleChange(inc, changes) {
      // We need a helper variable that will store how many nodes are to be still handled for this change item.
      // `nodesToHandle` (how many nodes still need to be handled) and `howMany` (how many nodes were affected)
      // needs to be differentiated.
      //
      // This comes up when there are multiple changes that are affected by `inc` change item.
      //
      // For example: assume two insert changes: `{ offset: 2, howMany: 1 }` and `{ offset: 5, howMany: 1 }`.
      // Assume that `inc` change is remove `{ offset: 2, howMany: 2, nodesToHandle: 2 }`.
      //
      // Then, we:
      // - "forget" about first insert change (it is "eaten" by remove),
      // - because of that, at the end we will want to remove only one node (`nodesToHandle = 1`),
      // - but still we have to change offset of the second insert change from `5` to `3`!
      //
      // So, `howMany` does not change throughout items transformation and keeps information about how many nodes were affected,
      // while `nodesToHandle` means how many nodes need to be handled after the change item is transformed by other changes.
      inc.nodesToHandle = inc.howMany;

      var _iterator10 = _createForOfIteratorHelper(changes),
          _step10;

      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var old = _step10.value;
          var incEnd = inc.offset + inc.howMany;
          var oldEnd = old.offset + old.howMany;

          if (inc.type == 'insert') {
            if (old.type == 'insert') {
              if (inc.offset <= old.offset) {
                old.offset += inc.howMany;
              } else if (inc.offset < oldEnd) {
                old.howMany += inc.nodesToHandle;
                inc.nodesToHandle = 0;
              }
            }

            if (old.type == 'remove') {
              if (inc.offset < old.offset) {
                old.offset += inc.howMany;
              }
            }

            if (old.type == 'attribute') {
              if (inc.offset <= old.offset) {
                old.offset += inc.howMany;
              } else if (inc.offset < oldEnd) {
                // This case is more complicated, because attribute change has to be split into two.
                // Example (assume that uppercase and lowercase letters mean different attributes):
                //
                // initial state:		abcxyz
                // attribute change:	aBCXYz
                // incoming insert:		aBCfooXYz
                //
                // Change ranges cannot intersect because each item has to be described exactly (it was either
                // not changed, inserted, removed, or its attribute was changed). That's why old attribute
                // change has to be split and both parts has to be handled separately from now on.
                var howMany = old.howMany;
                old.howMany = inc.offset - old.offset; // Add the second part of attribute change to the beginning of processed array so it won't
                // be processed again in this loop.

                changes.unshift({
                  type: 'attribute',
                  offset: incEnd,
                  howMany: howMany - old.howMany,
                  count: this._changeCount++
                });
              }
            }
          }

          if (inc.type == 'remove') {
            if (old.type == 'insert') {
              if (incEnd <= old.offset) {
                old.offset -= inc.howMany;
              } else if (incEnd <= oldEnd) {
                if (inc.offset < old.offset) {
                  var intersectionLength = incEnd - old.offset;
                  old.offset = inc.offset;
                  old.howMany -= intersectionLength;
                  inc.nodesToHandle -= intersectionLength;
                } else {
                  old.howMany -= inc.nodesToHandle;
                  inc.nodesToHandle = 0;
                }
              } else {
                if (inc.offset <= old.offset) {
                  inc.nodesToHandle -= old.howMany;
                  old.howMany = 0;
                } else if (inc.offset < oldEnd) {
                  var _intersectionLength = oldEnd - inc.offset;

                  old.howMany -= _intersectionLength;
                  inc.nodesToHandle -= _intersectionLength;
                }
              }
            }

            if (old.type == 'remove') {
              if (incEnd <= old.offset) {
                old.offset -= inc.howMany;
              } else if (inc.offset < old.offset) {
                inc.nodesToHandle += old.howMany;
                old.howMany = 0;
              }
            }

            if (old.type == 'attribute') {
              if (incEnd <= old.offset) {
                old.offset -= inc.howMany;
              } else if (inc.offset < old.offset) {
                var _intersectionLength2 = incEnd - old.offset;

                old.offset = inc.offset;
                old.howMany -= _intersectionLength2;
              } else if (inc.offset < oldEnd) {
                if (incEnd <= oldEnd) {
                  // On first sight in this case we don't need to split attribute operation into two.
                  // However the changes set is later converted to actions (see `_generateActionsFromChanges`).
                  // For that reason, no two changes may intersect.
                  // So we cannot have an attribute change that "contains" remove change.
                  // Attribute change needs to be split.
                  var _howMany = old.howMany;
                  old.howMany = inc.offset - old.offset;
                  var howManyAfter = _howMany - old.howMany - inc.nodesToHandle; // Add the second part of attribute change to the beginning of processed array so it won't
                  // be processed again in this loop.

                  changes.unshift({
                    type: 'attribute',
                    offset: inc.offset,
                    howMany: howManyAfter,
                    count: this._changeCount++
                  });
                } else {
                  old.howMany -= oldEnd - inc.offset;
                }
              }
            }
          }

          if (inc.type == 'attribute') {
            // In case of attribute change, `howMany` should be kept same as `nodesToHandle`. It's not an error.
            if (old.type == 'insert') {
              if (inc.offset < old.offset && incEnd > old.offset) {
                if (incEnd > oldEnd) {
                  // This case is similar to a case described when incoming change was insert and old change was attribute.
                  // See comment above.
                  //
                  // This time incoming change is attribute. We need to split incoming change in this case too.
                  // However this time, the second part of the attribute change needs to be processed further
                  // because there might be other changes that it collides with.
                  var attributePart = {
                    type: 'attribute',
                    offset: oldEnd,
                    howMany: incEnd - oldEnd,
                    count: this._changeCount++
                  };

                  this._handleChange(attributePart, changes);

                  changes.push(attributePart);
                }

                inc.nodesToHandle = old.offset - inc.offset;
                inc.howMany = inc.nodesToHandle;
              } else if (inc.offset >= old.offset && inc.offset < oldEnd) {
                if (incEnd > oldEnd) {
                  inc.nodesToHandle = incEnd - oldEnd;
                  inc.offset = oldEnd;
                } else {
                  inc.nodesToHandle = 0;
                }
              }
            }

            if (old.type == 'remove') {
              // This is a case when attribute change "contains" remove change.
              // The attribute change needs to be split into two because changes cannot intersect.
              if (inc.offset < old.offset && incEnd > old.offset) {
                var _attributePart = {
                  type: 'attribute',
                  offset: old.offset,
                  howMany: incEnd - old.offset,
                  count: this._changeCount++
                };

                this._handleChange(_attributePart, changes);

                changes.push(_attributePart);
                inc.nodesToHandle = old.offset - inc.offset;
                inc.howMany = inc.nodesToHandle;
              }
            }

            if (old.type == 'attribute') {
              // There are only two conflicting scenarios possible here:
              if (inc.offset >= old.offset && incEnd <= oldEnd) {
                // `old` change includes `inc` change, or they are the same.
                inc.nodesToHandle = 0;
                inc.howMany = 0;
                inc.offset = 0;
              } else if (inc.offset <= old.offset && incEnd >= oldEnd) {
                // `inc` change includes `old` change.
                old.howMany = 0;
              }
            }
          }
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }

      inc.howMany = inc.nodesToHandle;
      delete inc.nodesToHandle;
    }
    /**
     * Returns an object with a single insert change description.
     *
     * @private
     * @param {module:engine/model/element~Element} parent The element in which the change happened.
     * @param {Number} offset The offset at which change happened.
     * @param {String} name The name of the removed element or `'$text'` for a character.
     * @returns {Object} The diff item.
     */

  }, {
    key: "_getInsertDiff",
    value: function _getInsertDiff(parent, offset, name) {
      return {
        type: 'insert',
        position: Position._createAt(parent, offset),
        name: name,
        length: 1,
        changeCount: this._changeCount++
      };
    }
    /**
     * Returns an object with a single remove change description.
     *
     * @private
     * @param {module:engine/model/element~Element} parent The element in which change happened.
     * @param {Number} offset The offset at which change happened.
     * @param {String} name The name of the removed element or `'$text'` for a character.
     * @returns {Object} The diff item.
     */

  }, {
    key: "_getRemoveDiff",
    value: function _getRemoveDiff(parent, offset, name) {
      return {
        type: 'remove',
        position: Position._createAt(parent, offset),
        name: name,
        length: 1,
        changeCount: this._changeCount++
      };
    }
    /**
     * Returns an array of objects where each one is a single attribute change description.
     *
     * @private
     * @param {module:engine/model/range~Range} range The range where the change happened.
     * @param {Map} oldAttributes A map, map iterator or compatible object that contains attributes before the change.
     * @param {Map} newAttributes A map, map iterator or compatible object that contains attributes after the change.
     * @returns {Array.<Object>} An array containing one or more diff items.
     */

  }, {
    key: "_getAttributesDiff",
    value: function _getAttributesDiff(range, oldAttributes, newAttributes) {
      // Results holder.
      var diffs = []; // Clone new attributes as we will be performing changes on this object.

      newAttributes = new Map(newAttributes); // Look through old attributes.

      var _iterator11 = _createForOfIteratorHelper(oldAttributes),
          _step11;

      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var _ref14 = _step11.value;

          var _ref11 = _slicedToArray(_ref14, 2);

          var key = _ref11[0];
          var oldValue = _ref11[1];
          // Check what is the new value of the attribute (or if it was removed).
          var newValue = newAttributes.has(key) ? newAttributes.get(key) : null; // If values are different (or attribute was removed)...

          if (newValue !== oldValue) {
            // Add diff item.
            diffs.push({
              type: 'attribute',
              position: range.start,
              range: range.clone(),
              length: 1,
              attributeKey: key,
              attributeOldValue: oldValue,
              attributeNewValue: newValue,
              changeCount: this._changeCount++
            });
          } // Prevent returning two diff items for the same change.


          newAttributes.delete(key);
        } // Look through new attributes that weren't handled above.

      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }

      var _iterator12 = _createForOfIteratorHelper(newAttributes),
          _step12;

      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var _ref15 = _step12.value;

          var _ref13 = _slicedToArray(_ref15, 2);

          var _key = _ref13[0];
          var _newValue = _ref13[1];
          // Each of them is a new attribute. Add diff item.
          diffs.push({
            type: 'attribute',
            position: range.start,
            range: range.clone(),
            length: 1,
            attributeKey: _key,
            attributeOldValue: null,
            attributeNewValue: _newValue,
            changeCount: this._changeCount++
          });
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }

      return diffs;
    }
    /**
     * Checks whether given element or any of its parents is an element that is buffered as an inserted element.
     *
     * @private
     * @param {module:engine/model/element~Element} element Element to check.
     * @returns {Boolean}
     */

  }, {
    key: "_isInInsertedElement",
    value: function _isInInsertedElement(element) {
      var parent = element.parent;

      if (!parent) {
        return false;
      }

      var changes = this._changesInElement.get(parent);

      var offset = element.startOffset;

      if (changes) {
        var _iterator13 = _createForOfIteratorHelper(changes),
            _step13;

        try {
          for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
            var change = _step13.value;

            if (change.type == 'insert' && offset >= change.offset && offset < change.offset + change.howMany) {
              return true;
            }
          }
        } catch (err) {
          _iterator13.e(err);
        } finally {
          _iterator13.f();
        }
      }

      return this._isInInsertedElement(parent);
    }
    /**
     * Removes deeply all buffered changes that are registered in elements from range specified by `parent`, `offset`
     * and `howMany`.
     *
     * @private
     * @param {module:engine/model/element~Element} parent
     * @param {Number} offset
     * @param {Number} howMany
     */

  }, {
    key: "_removeAllNestedChanges",
    value: function _removeAllNestedChanges(parent, offset, howMany) {
      var range = new Range(Position._createAt(parent, offset), Position._createAt(parent, offset + howMany));

      var _iterator14 = _createForOfIteratorHelper(range.getItems({
        shallow: true
      })),
          _step14;

      try {
        for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
          var item = _step14.value;

          if (item.is('element')) {
            this._elementSnapshots.delete(item);

            this._changesInElement.delete(item);

            this._removeAllNestedChanges(item, 0, item.maxOffset);
          }
        }
      } catch (err) {
        _iterator14.e(err);
      } finally {
        _iterator14.f();
      }
    }
  }]);

  return Differ;
}(); // Returns an array that is a copy of passed child list with the exception that text nodes are split to one or more
// objects, each representing one character and attributes set on that character.


export { Differ as default };

function _getChildrenSnapshot(children) {
  var snapshot = [];

  var _iterator15 = _createForOfIteratorHelper(children),
      _step15;

  try {
    for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
      var child = _step15.value;

      if (child.is('$text')) {
        for (var i = 0; i < child.data.length; i++) {
          snapshot.push({
            name: '$text',
            attributes: new Map(child.getAttributes())
          });
        }
      } else {
        snapshot.push({
          name: child.name,
          attributes: new Map(child.getAttributes())
        });
      }
    }
  } catch (err) {
    _iterator15.e(err);
  } finally {
    _iterator15.f();
  }

  return snapshot;
} // Generates array of actions for given changes set.
// It simulates what `diff` function does.
// Generated actions are:
// - 'e' for 'equal' - when item at that position did not change,
// - 'i' for 'insert' - when item at that position was inserted,
// - 'r' for 'remove' - when item at that position was removed,
// - 'a' for 'attribute' - when item at that position has it attributes changed.
//
// Example (assume that uppercase letters have bold attribute, compare with function code):
//
// children before:	fooBAR
// children after:	foxybAR
//
// changes: type: remove, offset: 1, howMany: 1
//			type: insert, offset: 2, howMany: 2
//			type: attribute, offset: 4, howMany: 1
//
// expected actions: equal (f), remove (o), equal (o), insert (x), insert (y), attribute (b), equal (A), equal (R)
//
// steps taken by th script:
//
// 1. change = "type: remove, offset: 1, howMany: 1"; offset = 0; oldChildrenHandled = 0
//    1.1 between this change and the beginning is one not-changed node, fill with one equal action, one old child has been handled
//    1.2 this change removes one node, add one remove action
//    1.3 change last visited `offset` to 1
//    1.4 since an old child has been removed, one more old child has been handled
//    1.5 actions at this point are: equal, remove
//
// 2. change = "type: insert, offset: 2, howMany: 2"; offset = 1; oldChildrenHandled = 2
//    2.1 between this change and previous change is one not-changed node, add equal action, another one old children has been handled
//    2.2 this change inserts two nodes, add two insert actions
//    2.3 change last visited offset to the end of the inserted range, that is 4
//    2.4 actions at this point are: equal, remove, equal, insert, insert
//
// 3. change = "type: attribute, offset: 4, howMany: 1"; offset = 4, oldChildrenHandled = 3
//    3.1 between this change and previous change are no not-changed nodes
//    3.2 this change changes one node, add one attribute action
//    3.3 change last visited `offset` to the end of change range, that is 5
//    3.4 since an old child has been changed, one more old child has been handled
//    3.5 actions at this point are: equal, remove, equal, insert, insert, attribute
//
// 4. after loop oldChildrenHandled = 4, oldChildrenLength = 6 (fooBAR is 6 characters)
//    4.1 fill up with two equal actions
//
// The result actions are: equal, remove, equal, insert, insert, attribute, equal, equal.


function _generateActionsFromChanges(oldChildrenLength, changes) {
  var actions = [];
  var offset = 0;
  var oldChildrenHandled = 0; // Go through all buffered changes.

  var _iterator16 = _createForOfIteratorHelper(changes),
      _step16;

  try {
    for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
      var change = _step16.value;

      // First, fill "holes" between changes with "equal" actions.
      if (change.offset > offset) {
        for (var _i3 = 0; _i3 < change.offset - offset; _i3++) {
          actions.push('e');
        }

        oldChildrenHandled += change.offset - offset;
      } // Then, fill up actions accordingly to change type.


      if (change.type == 'insert') {
        for (var _i4 = 0; _i4 < change.howMany; _i4++) {
          actions.push('i');
        } // The last handled offset is after inserted range.


        offset = change.offset + change.howMany;
      } else if (change.type == 'remove') {
        for (var _i5 = 0; _i5 < change.howMany; _i5++) {
          actions.push('r');
        } // The last handled offset is at the position where the nodes were removed.


        offset = change.offset; // We removed `howMany` old nodes, update `oldChildrenHandled`.

        oldChildrenHandled += change.howMany;
      } else {
        actions.push.apply(actions, _toConsumableArray('a'.repeat(change.howMany).split(''))); // The last handled offset is at the position after the changed range.

        offset = change.offset + change.howMany; // We changed `howMany` old nodes, update `oldChildrenHandled`.

        oldChildrenHandled += change.howMany;
      }
    } // Fill "equal" actions at the end of actions set. Use `oldChildrenHandled` to see how many children
    // has not been changed / removed at the end of their parent.

  } catch (err) {
    _iterator16.e(err);
  } finally {
    _iterator16.f();
  }

  if (oldChildrenHandled < oldChildrenLength) {
    for (var i = 0; i < oldChildrenLength - oldChildrenHandled - offset; i++) {
      actions.push('e');
    }
  }

  return actions;
} // Filter callback for Array.filter that filters out change entries that are in graveyard.


function _changesInGraveyardFilter(entry) {
  var posInGy = entry.position && entry.position.root.rootName == '$graveyard';
  var rangeInGy = entry.range && entry.range.root.rootName == '$graveyard';
  return !posInGy && !rangeInGy;
}
/**
 * The single diff item.
 *
 * Could be one of:
 *
 * * {@link module:engine/model/differ~DiffItemInsert `DiffItemInsert`},
 * * {@link module:engine/model/differ~DiffItemRemove `DiffItemRemove`},
 * * {@link module:engine/model/differ~DiffItemAttribute `DiffItemAttribute`}.
 *
 * @interface DiffItem
 */

/**
 * The single diff item for inserted nodes.
 *
 * @class DiffItemInsert
 * @implements module:engine/model/differ~DiffItem
 */

/**
 * The type of diff item.
 *
 * @member {'insert'} module:engine/model/differ~DiffItemInsert#type
 */

/**
 * The name of the inserted elements or `'$text'` for a text node.
 *
 * @member {String} module:engine/model/differ~DiffItemInsert#name
 */

/**
 * The position where the node was inserted.
 *
 * @member {module:engine/model/position~Position} module:engine/model/differ~DiffItemInsert#position
 */

/**
 * The length of an inserted text node. For elements it is always 1 as each inserted element is counted as a one.
 *
 * @member {Number} module:engine/model/differ~DiffItemInsert#length
 */

/**
 * The single diff item for removed nodes.
 *
 * @class DiffItemRemove
 * @implements module:engine/model/differ~DiffItem
 */

/**
 * The type of diff item.
 *
 * @member {'remove'} module:engine/model/differ~DiffItemRemove#type
 */

/**
 * The name of the removed element or `'$text'` for a text node.
 *
 * @member {String} module:engine/model/differ~DiffItemRemove#name
 */

/**
 * The position where the node was removed.
 *
 * @member {module:engine/model/position~Position} module:engine/model/differ~DiffItemRemove#position
 */

/**
 * The length of a removed text node. For elements it is always 1 as each removed element is counted as a one.
 *
 * @member {Number} module:engine/model/differ~DiffItemRemove#length
 */

/**
 * The single diff item for attribute change.
 *
 * @class DiffItemAttribute
 * @implements module:engine/model/differ~DiffItem
 */

/**
 * The type of diff item.
 *
 * @member {'attribute'} module:engine/model/differ~DiffItemAttribute#type
 */

/**
 * The name of the changed attribute.
 *
 * @member {String} module:engine/model/differ~DiffItemAttribute#attributeKey
 */

/**
 * An attribute previous value (before change).
 *
 * @member {String} module:engine/model/differ~DiffItemAttribute#attributeOldValue
 */

/**
 * An attribute new value (after change).
 *
 * @member {String} module:engine/model/differ~DiffItemAttribute#attributeNewValue
 */

/**
 * The range where the change happened.
 *
 * @member {module:engine/model/range~Range} module:engine/model/differ~DiffItemAttribute#range
 */